import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Términos y Condiciones"
        description="Términos y condiciones de uso de erm-media. Conoce nuestras políticas sobre propiedad intelectual, servicios profesionales y limitaciones de responsabilidad."
        keywords="términos y condiciones, términos de uso, condiciones de servicio, legal, propiedad intelectual"
        canonicalUrl="https://erm-media.com/terminos"
        type="article"
      />
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-8">
          Términos y Condiciones
        </h1>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
          <p className="text-muted-foreground">
            <strong>Fecha de última actualización:</strong> <span suppressHydrationWarning>{new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">1. Aceptación de los Términos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Bienvenido a erm-media. Al acceder y utilizar este sitio web, aceptas cumplir y estar sujeto a los
              siguientes términos y condiciones de uso. Si no estás de acuerdo con alguna parte de estos términos,
              te recomendamos que no utilices nuestro sitio web.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Estos términos se aplican a todos los visitantes, usuarios y otras personas que accedan o utilicen
              el servicio.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">2. Descripción del Servicio</h2>
            <p className="text-muted-foreground leading-relaxed">
              erm-media es una empresa especializada en el desarrollo de proyectos informáticos, que ofrece servicios
              profesionales incluyendo, pero no limitados a:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Desarrollo de landing pages y sitios web corporativos</li>
              <li>Desarrollo de aplicaciones web personalizadas</li>
              <li>Sistemas empresariales y soluciones de alto rendimiento</li>
              <li>Consultoría y asesoramiento tecnológico</li>
              <li>Diseño y desarrollo de soluciones digitales a medida</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">3. Uso del Sitio Web</h2>
            <h3 className="text-xl font-semibold text-foreground">3.1 Uso permitido</h3>
            <p className="text-muted-foreground leading-relaxed">
              Te concedemos una licencia limitada, no exclusiva, intransferible y revocable para acceder y utilizar
              este sitio web para los siguientes propósitos:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Obtener información sobre nuestros servicios</li>
              <li>Contactarnos para consultas comerciales legítimas</li>
              <li>Explorar nuestro portafolio y capacidades</li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mt-4">3.2 Uso prohibido</h3>
            <p className="text-muted-foreground leading-relaxed">
              No está permitido:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Utilizar el sitio para fines ilegales o no autorizados</li>
              <li>Intentar acceder a áreas restringidas del sitio o servidores</li>
              <li>Interferir con el funcionamiento del sitio web</li>
              <li>Copiar, reproducir, modificar o distribuir contenido sin autorización</li>
              <li>Utilizar bots, scrapers o herramientas automatizadas sin permiso</li>
              <li>Transmitir malware, virus o código malicioso</li>
              <li>Suplantar la identidad de otra persona o entidad</li>
              <li>Recopilar información de otros usuarios sin su consentimiento</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">4. Propiedad Intelectual</h2>
            <h3 className="text-xl font-semibold text-foreground">4.1 Contenido del sitio</h3>
            <p className="text-muted-foreground leading-relaxed">
              Todo el contenido de este sitio web, incluyendo pero no limitado a textos, gráficos, logotipos, iconos,
              imágenes, clips de audio, descargas digitales y compilaciones de datos, es propiedad de erm-media o de
              sus proveedores de contenido y está protegido por las leyes de propiedad intelectual nacionales e
              internacionales.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-4">4.2 Marcas registradas</h3>
            <p className="text-muted-foreground leading-relaxed">
              erm-media y todos los logotipos relacionados son marcas comerciales de nuestra empresa. No puedes
              utilizar estas marcas sin nuestro consentimiento previo por escrito.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-4">4.3 Trabajo personalizado</h3>
            <p className="text-muted-foreground leading-relaxed">
              Los derechos de propiedad intelectual sobre los proyectos desarrollados específicamente para clientes
              se regirán por los acuerdos contractuales individuales establecidos para cada proyecto.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">5. Servicios Profesionales</h2>
            <h3 className="text-xl font-semibold text-foreground">5.1 Contratación de servicios</h3>
            <p className="text-muted-foreground leading-relaxed">
              La contratación de nuestros servicios profesionales se formalizará mediante acuerdos específicos que
              establecerán:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Alcance del proyecto</li>
              <li>Plazos de entrega</li>
              <li>Costos y condiciones de pago</li>
              <li>Derechos de propiedad intelectual</li>
              <li>Garantías y soporte</li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mt-4">5.2 Presupuestos</h3>
            <p className="text-muted-foreground leading-relaxed">
              Los presupuestos proporcionados son estimaciones basadas en la información disponible en el momento
              de su elaboración. Los costos finales se establecerán en el contrato formal del proyecto.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">6. Privacidad y Protección de Datos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Tu privacidad es importante para nosotros. El uso de tu información personal se rige por nuestra
              Política de Privacidad, que forma parte integral de estos términos y condiciones. Te recomendamos
              leer nuestra Política de Privacidad para entender cómo recopilamos, usamos y protegemos tu información.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">7. Limitación de Responsabilidad</h2>
            <h3 className="text-xl font-semibold text-foreground">7.1 Uso del sitio web</h3>
            <p className="text-muted-foreground leading-relaxed">
              Este sitio web se proporciona "tal cual" y "según disponibilidad". erm-media no garantiza que:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>El sitio web funcionará sin interrupciones o errores</li>
              <li>Los defectos serán corregidos inmediatamente</li>
              <li>El sitio web estará libre de virus o componentes dañinos</li>
              <li>La información sea completamente precisa o actualizada</li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mt-4">7.2 Exclusión de garantías</h3>
            <p className="text-muted-foreground leading-relaxed">
              En la máxima medida permitida por la ley, excluimos todas las garantías, expresas o implícitas,
              incluyendo pero no limitado a garantías de comerciabilidad, idoneidad para un propósito particular
              y no infracción.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-4">7.3 Limitación de daños</h3>
            <p className="text-muted-foreground leading-relaxed">
              En ningún caso erm-media será responsable de daños directos, indirectos, incidentales, especiales,
              consecuentes o punitivos que resulten de:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>El uso o la imposibilidad de usar el sitio web</li>
              <li>Acceso no autorizado o alteración de tus transmisiones o datos</li>
              <li>Declaraciones o conducta de terceros en el sitio web</li>
              <li>Cualquier otro asunto relacionado con el sitio web</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">8. Indemnización</h2>
            <p className="text-muted-foreground leading-relaxed">
              Aceptas indemnizar, defender y mantener indemne a erm-media, sus directores, empleados, agentes y
              socios de y contra cualquier reclamación, demanda, pérdida, responsabilidad, costo o gasto (incluyendo
              honorarios razonables de abogados) que surjan de:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Tu uso del sitio web</li>
              <li>Tu violación de estos términos y condiciones</li>
              <li>Tu violación de cualquier derecho de terceros</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">9. Enlaces a Sitios de Terceros</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nuestro sitio web puede contener enlaces a sitios web de terceros que no son propiedad ni están
              controlados por erm-media. No tenemos control sobre, y no asumimos responsabilidad por el contenido,
              políticas de privacidad o prácticas de sitios web de terceros. Reconoces y aceptas que erm-media no
              será responsable, directa o indirectamente, de cualquier daño o pérdida causado o presuntamente causado
              por el uso o la confianza en dichos contenidos, bienes o servicios disponibles en o a través de dichos
              sitios web.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">10. Modificaciones del Servicio y Términos</h2>
            <h3 className="text-xl font-semibold text-foreground">10.1 Modificaciones del servicio</h3>
            <p className="text-muted-foreground leading-relaxed">
              Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto del sitio web
              en cualquier momento, sin previo aviso.
            </p>

            <h3 className="text-xl font-semibold text-foreground mt-4">10.2 Modificaciones de los términos</h3>
            <p className="text-muted-foreground leading-relaxed">
              Podemos revisar estos términos y condiciones en cualquier momento sin previo aviso. Al continuar
              utilizando este sitio web después de que se publiquen dichas revisiones, aceptas estar sujeto a los
              términos revisados. Te recomendamos revisar periódicamente esta página para estar informado de cualquier
              cambio.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">11. Terminación</h2>
            <p className="text-muted-foreground leading-relaxed">
              Podemos terminar o suspender tu acceso al sitio web inmediatamente, sin previo aviso ni responsabilidad,
              por cualquier motivo, incluyendo sin limitación si violas estos términos y condiciones. Todas las
              disposiciones de estos términos que por su naturaleza deberían sobrevivir a la terminación, sobrevivirán
              a la terminación, incluyendo, sin limitación, disposiciones de propiedad, exenciones de garantía,
              indemnización y limitaciones de responsabilidad.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">12. Ley Aplicable y Jurisdicción</h2>
            <p className="text-muted-foreground leading-relaxed">
              Estos términos se regirán e interpretarán de acuerdo con las leyes de España, sin tener en cuenta
              sus disposiciones sobre conflicto de leyes. Cualquier disputa que surja de o en relación con estos
              términos se someterá a la jurisdicción exclusiva de los tribunales de España.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">13. Divisibilidad</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si alguna disposición de estos términos se considera inválida, ilegal o inaplicable por un tribunal
              de jurisdicción competente, dicha disposición se eliminará o limitará al mínimo necesario, y las
              disposiciones restantes de estos términos continuarán en pleno vigor y efecto.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">14. Renuncia</h2>
            <p className="text-muted-foreground leading-relaxed">
              El hecho de que no ejerzamos o hagamos cumplir cualquier derecho o disposición de estos términos no
              constituirá una renuncia a dicho derecho o disposición. Cualquier renuncia a cualquier disposición
              de estos términos solo será efectiva si se hace por escrito y está firmada por nosotros.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">15. Acuerdo Completo</h2>
            <p className="text-muted-foreground leading-relaxed">
              Estos términos y condiciones, junto con nuestra Política de Privacidad, constituyen el acuerdo completo
              entre tú y erm-media con respecto al uso de este sitio web, y reemplazan todos los acuerdos anteriores
              o contemporáneos, escritos u orales, con respecto a dicho tema.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">16. Contacto</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si tienes preguntas sobre estos Términos y Condiciones, puedes contactarnos a través de:
            </p>
            <ul className="list-none text-muted-foreground space-y-2 ml-4">
              <li><strong>Empresa:</strong> erm-media</li>
              <li><strong>Sitio web:</strong> Formulario de contacto disponible en nuestra página principal</li>
            </ul>
          </section>

          <div className="border-t border-border pt-6 mt-8">
            <p className="text-sm text-muted-foreground">
              Al utilizar este sitio web, reconoces que has leído, entendido y aceptas estar sujeto a estos
              Términos y Condiciones.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
